import CalendarIcon from '$assets/svgs/calendamenuwhiteicon.svg?react';
import NotificationIcon from '$assets/svgs/notification.svg?react';
import UserSquareIcon from '$assets/svgs/user-square-icon.svg?react';
import WalletIcon from '$assets/svgs/wallet-icon.svg?react';
import {RouteSection, getRoute} from '$utils/route';
import {RoutePath} from '$constants/routes';
import {UserRoleName} from '$modules/admin/constant';

export const DRAWER_WIDTH = 277;

export enum NavigationItem {
  Calendar = 'CALENDAR',
  PatientList = 'PATIENT_LIST',
  Finance = 'FINANCE',
  Notification = 'NOTIFICATION',
}

export const NAVIGATION_TOP_ITEMS: {
  id: NavigationItem;
  title: string;
  route: string;
  icon: React.ReactNode;
  excludedRoles?: UserRoleName[];
  subItems?: {
    title: string;
    route: string;
    excludedRoles?: UserRoleName[];
  }[];
}[] = [
  {
    id: NavigationItem.Calendar,
    title: 'Calendar',
    route: getRoute(RouteSection.Calendar),
    icon: <CalendarIcon />,
  },
  {
    id: NavigationItem.PatientList,
    title: 'Patient list',
    route: getRoute(RouteSection.PatientList),
    icon: <UserSquareIcon />,
  },
  {
    id: NavigationItem.Finance,
    title: 'Finance',
    route: getRoute(RouteSection.Finance),
    icon: <WalletIcon />,
    excludedRoles: [
      UserRoleName.Patient,
      UserRoleName.Doctor,
      UserRoleName.Frontdesk,
    ],
    subItems: [
      {
        title: 'Dashboard',
        route: getRoute(
          RouteSection.Finance,
          RoutePath.staff.finance.dashboard.index
        ),
      },
      {
        title: 'Payment list',
        route: getRoute(
          RouteSection.Finance,
          RoutePath.staff.finance.paymentList
        ),
        excludedRoles: [UserRoleName.Patient, UserRoleName.Doctor],
      },
      {
        title: 'Insurance claims',
        route: getRoute(
          RouteSection.Finance,
          RoutePath.staff.finance.insuranceClaims
        ),
        excludedRoles: [UserRoleName.Patient, UserRoleName.Doctor],
      },
    ],
  },
];

export const NAVIGATION_BOTTOM_ITEMS: {
  id: NavigationItem;
  title: string;
  route: string;
  icon: React.ReactNode;
  subItems?: {
    title: string;
    route: string;
  }[];
}[] = [
  {
    id: NavigationItem.Notification,
    title: 'Notifications',
    route: getRoute(RouteSection.Notification),
    icon: <NotificationIcon />,
  },
];
